module.exports = __webpack_public_path__ + "img/logo-mantura.9d727801.png";